import config from '../../../../../../config/khub-oauth2-config.json'

type KhubOAuth2App = {
  name: string;
  packageName: string;
};

type KhubOAuth2Provider = {
  name: string;
  apps: KhubOAuth2App[];
  clientId: string;
  frontendEnvVar: string;
};

const KHUB_OAUTH2_PROVIDERS: KhubOAuth2Provider[] = config.providers.map(provider => ({
  ...provider,
  clientId: import.meta.env[provider.frontendEnvVar] || '',
}));

export const khubAppOAuth2Config: Record<string, { apps: string[]; clientId: string }> = 
  KHUB_OAUTH2_PROVIDERS.reduce((acc, provider) => {
    acc[provider.name] = {
      apps: provider.apps.map(app => [app.name, app.packageName]).flat(),
      clientId: provider.clientId,
    };
    return acc;
  }, {} as Record<string, { apps: string[]; clientId: string }>); 